(function () {
  'use strict';

  // Configuration for the accessibility widget
  const WIDGET_CONFIG = {
    storageKey: 'a11y-widget-settings',
    defaultLang: 'en',
    translations: {
      en: {
        title: 'Accessibility Settings',
        readingMask: 'Reading Mask',
        highContrast: 'High Contrast',
        fontSize: 'Font Size',
        lineHeight: 'Line Height',
        letterSpacing: 'Letter Spacing',
        contentScale: 'Content Scale',
        dyslexiaFont: 'Readable Font',
        textAlign: 'Align Right',
        textAlignCenter: 'Center',
        textAlignLeft: 'Align Left',
        highlightLinks: 'Underline Links',
        hideImages: 'Hide Images',
        highlightHeadings: 'Highlight Titles',
        textMagnifier: 'Cursor Reading Aid',
        reset: 'Reset',
        poweredBy: 'Powered by',
        darkMode: 'Dark Mode',
        focusOutline: 'Show Focus Outline',
        reduceMotion: 'Reduce Motion',
        cursorSize: 'Large Cursor',
        stopAutoplay: 'Stop Autoplay',
        invertColors: 'Invert Colors',
        columnWidth: 'Column Width',
      },
      /*
      hr: {
        title: 'Postavke pristupačnosti',
        readingMask: 'Maska za čitanje',
        highContrast: 'Visoki kontrast',
        fontSize: 'Veličina fonta',
        lineHeight: 'Visina retka',
        letterSpacing: 'Razmak slova',
        contentScale: 'Skaliranje sadržaja',
        dyslexiaFont: 'Čitljiv font',
        textAlign: 'Poravnaj desno',
        textAlignCenter: 'Centar',
        textAlignLeft: 'Poravnaj lijevo',
        highlightLinks: 'Podcrtaj linkove',
        hideImages: 'Sakrij slike',
        highlightHeadings: 'Istakni naslove',
        textMagnifier: 'Povećalo za čitanje',
        reset: 'Poništi',
        poweredBy: 'Omogućio',
        darkMode: 'Tamni način',
        focusOutline: 'Prikaži obrub fokusiranja',
        reduceMotion: 'Smanji animacije',
        cursorSize: 'Veliki kursor',
        stopAutoplay: 'Zaustavi automatsko pokretanje',
        invertColors: 'Invertiraj boje',
        columnWidth: 'Širina stupca',
      },
      */
    },
  };

  /**
   * Icon path data extracted from Font Awesome Free 6.7.2 (Icons: CC BY 4.0).
   * Inlined as SVG so the widget no longer ships ~1 MB of webfonts to draw 21 glyphs.
   * Each entry is [viewBox width, path data]; the viewBox height is always 512.
   */
  const ICONS = {
    'universal-access': [512, 'M0 256Q1 186 34 128Q68 70 128 34Q189 0 256 0Q323 0 384 34Q444 70 478 128Q511 186 512 256Q511 326 478 384Q444 442 384 478Q323 512 256 512Q189 512 128 478Q68 442 34 384Q1 326 0 256ZM162 170Q141 163 130 183Q123 204 143 214L155 219Q180 230 208 235V286Q208 292 206 298L177 384Q172 406 193 415Q214 420 223 399L247 326Q250 320 256 320Q263 320 265 326L289 399Q298 420 320 415Q340 406 335 384L306 298Q304 292 304 286V235Q332 230 358 219L370 214Q389 204 382 183Q372 163 351 170L339 175Q299 192 256 192Q213 192 173 175L161 170ZM256 160Q279 159 291 140Q301 120 291 100Q279 81 256 80Q233 81 221 100Q211 120 221 140Q233 159 256 160Z'],
    'times': [384, 'M343 151Q352 141 352 128Q352 115 343 105Q333 96 320 96Q307 96 297 105L192 211L87 105Q77 96 64 96Q51 96 41 105Q32 115 32 128Q32 141 41 151L147 256L41 361Q32 371 32 384Q32 397 41 407Q51 416 64 416Q77 416 87 407L192 301L297 407Q307 416 320 416Q333 416 343 407Q352 397 352 384Q352 371 343 361L237 256L343 151Z'],
    'undo': [512, 'M126 160H176H126H176Q190 160 199 169Q208 178 208 192Q208 206 199 215Q190 224 176 224H48Q34 224 25 215Q16 206 16 192V64Q16 50 25 41Q34 32 48 32Q62 32 71 41Q80 50 80 64V115L98 98Q142 54 199 39Q256 25 313 39Q370 54 414 98Q458 142 473 199Q487 256 473 313Q458 370 414 414Q370 458 313 473Q256 487 199 473Q142 458 98 414Q88 405 88 392Q88 379 98 369Q107 360 120 360Q133 360 143 369Q192 416 256 416Q320 416 369 369Q416 320 416 256Q416 192 369 143Q320 96 256 96Q192 96 143 143L126 160Z'],
    'eye': [576, 'M288 32Q227 33 179 56Q131 79 95 113Q60 146 37 181Q14 216 3 244Q-2 256 3 268Q14 296 37 331Q60 366 95 399Q131 433 179 456Q227 479 288 480Q349 479 397 456Q445 433 481 399Q516 366 539 331Q562 296 574 268Q579 256 574 244Q562 216 539 181Q516 146 481 113Q445 79 397 56Q349 33 288 32ZM144 256Q144 217 163 184Q182 151 216 131Q250 112 288 112Q326 112 360 131Q394 151 413 184Q432 217 432 256Q432 295 413 328Q394 361 360 381Q326 400 288 400Q250 400 216 381Q182 361 163 328Q144 295 144 256ZM288 192Q287 219 269 237Q251 255 224 256Q213 256 204 253Q194 251 192 260Q192 270 195 281Q207 320 240 339Q273 358 313 349Q352 337 371 304Q390 271 381 231Q372 200 348 181Q323 162 292 160Q283 162 285 172Q288 181 288 192Z'],
    'adjust': [512, 'M448 256Q446 174 392 120Q338 66 256 64V448Q338 446 392 392Q446 338 448 256ZM0 256Q1 186 34 128Q68 70 128 34Q189 0 256 0Q323 0 384 34Q444 70 478 128Q511 186 512 256Q511 326 478 384Q444 442 384 478Q323 512 256 512Q189 512 128 478Q68 442 34 384Q1 326 0 256Z'],
    'moon': [384, 'M224 32Q161 33 111 63Q60 92 30 143Q1 193 0 256Q1 319 31 369Q60 420 111 449Q161 479 224 480Q317 478 379 417Q387 408 382 398Q377 388 365 389Q351 392 335 392Q261 390 211 340Q162 291 160 216Q160 166 184 126Q209 86 249 63Q259 57 257 45Q254 35 242 33Q233 32 223 32Z'],
    'font': [448, 'M254 53Q245 33 224 32Q203 33 194 53L58 416H32Q18 416 9 425Q0 434 0 448Q0 462 9 471Q18 480 32 480H128Q142 480 151 471Q160 462 160 448Q160 434 151 425Q142 416 128 416H126L144 368H304L322 416H320Q306 416 297 425Q288 434 288 448Q288 462 297 471Q306 480 320 480H416Q430 480 439 471Q448 462 448 448Q448 434 439 425Q430 416 416 416H390L254 53ZM280 304H168H280H168L224 155L280 304Z'],
    'align-right': [448, 'M448 64Q448 78 439 87Q430 96 416 96H192Q178 96 169 87Q160 78 160 64Q160 50 169 41Q178 32 192 32H416Q430 32 439 41Q448 50 448 64ZM448 320Q448 334 439 343Q430 352 416 352H192Q178 352 169 343Q160 334 160 320Q160 306 169 297Q178 288 192 288H416Q430 288 439 297Q448 306 448 320ZM0 192Q0 178 9 169Q18 160 32 160H416Q430 160 439 169Q448 178 448 192Q448 206 439 215Q430 224 416 224H32Q18 224 9 215Q0 206 0 192ZM448 448Q448 462 439 471Q430 480 416 480H32Q18 480 9 471Q0 462 0 448Q0 434 9 425Q18 416 32 416H416Q430 416 439 425Q448 434 448 448Z'],
    'align-center': [448, 'M352 64Q352 50 343 41Q334 32 320 32H128Q114 32 105 41Q96 50 96 64Q96 78 105 87Q114 96 128 96H320Q334 96 343 87Q352 78 352 64ZM448 192Q448 178 439 169Q430 160 416 160H32Q18 160 9 169Q0 178 0 192Q0 206 9 215Q18 224 32 224H416Q430 224 439 215Q448 206 448 192ZM0 448Q0 462 9 471Q18 480 32 480H416Q430 480 439 471Q448 462 448 448Q448 434 439 425Q430 416 416 416H32Q18 416 9 425Q0 434 0 448ZM352 320Q352 306 343 297Q334 288 320 288H128Q114 288 105 297Q96 306 96 320Q96 334 105 343Q114 352 128 352H320Q334 352 343 343Q352 334 352 320Z'],
    'align-left': [448, 'M288 64Q288 78 279 87Q270 96 256 96H32Q18 96 9 87Q0 78 0 64Q0 50 9 41Q18 32 32 32H256Q270 32 279 41Q288 50 288 64ZM288 320Q288 334 279 343Q270 352 256 352H32Q18 352 9 343Q0 334 0 320Q0 306 9 297Q18 288 32 288H256Q270 288 279 297Q288 306 288 320ZM0 192Q0 178 9 169Q18 160 32 160H416Q430 160 439 169Q448 178 448 192Q448 206 439 215Q430 224 416 224H32Q18 224 9 215Q0 206 0 192ZM448 448Q448 462 439 471Q430 480 416 480H32Q18 480 9 471Q0 462 0 448Q0 434 9 425Q18 416 32 416H416Q430 416 439 425Q448 434 448 448Z'],
    'link': [640, 'M580 268Q622 223 622 165Q622 108 580 63Q541 26 489 21Q438 17 394 48L392 49Q381 57 379 70Q377 82 385 94Q393 104 405 106Q418 109 429 101L431 100Q456 83 484 85Q513 87 535 108Q558 133 558 165Q558 198 535 222L422 335Q397 358 365 358Q333 358 308 335Q287 313 285 284Q283 256 300 231L301 229Q308 218 306 206Q304 193 293 185Q282 177 270 179Q257 181 249 192L248 194Q217 238 221 290Q225 341 263 380Q308 422 365 422Q423 422 468 380L580 268ZM60 244Q18 289 18 347Q18 404 60 449Q99 486 151 491Q202 495 247 464L248 463Q259 455 261 442Q263 430 256 418Q247 408 235 406Q222 403 211 411L209 412Q184 429 156 427Q127 425 105 404Q82 379 82 347Q82 314 106 290L218 177Q243 154 275 154Q307 154 332 177Q353 199 355 228Q357 256 340 281L339 283Q332 294 334 307Q336 319 347 327Q358 335 370 333Q383 331 391 320L392 318Q423 274 419 222Q415 171 377 132Q332 90 275 90Q217 90 173 132L60 244Z'],
    'image': [512, 'M0 96Q1 69 19 51Q37 33 64 32H448Q475 33 493 51Q511 69 512 96V416Q511 443 493 461Q475 479 448 480H64Q37 479 19 461Q1 443 0 416V96ZM324 203Q316 192 304 192Q291 192 284 203L197 330L171 297Q163 288 152 288Q141 288 133 297L69 377Q61 389 66 402Q73 415 88 416H184H424Q438 416 445 403Q451 390 444 379L324 203ZM112 192Q139 191 154 168Q166 144 154 120Q139 97 112 96Q85 97 70 120Q58 144 70 168Q85 191 112 192Z'],
    'heading': [448, 'M0 64Q0 50 9 41Q18 32 32 32H80H128Q142 32 151 41Q160 50 160 64Q160 78 151 87Q142 96 128 96H112V208H336V96H320Q306 96 297 87Q288 78 288 64Q288 50 297 41Q306 32 320 32H368H416Q430 32 439 41Q448 50 448 64Q448 78 439 87Q430 96 416 96H400V240V416H416Q430 416 439 425Q448 434 448 448Q448 462 439 471Q430 480 416 480H368H320Q306 480 297 471Q288 462 288 448Q288 434 297 425Q306 416 320 416H336V272H112V416H128Q142 416 151 425Q160 434 160 448Q160 462 151 471Q142 480 128 480H80H32Q18 480 9 471Q0 462 0 448Q0 434 9 425Q18 416 32 416H48V240V96H32Q18 96 9 87Q0 78 0 64Z'],
    'search-plus': [512, 'M416 208Q415 278 376 331L503 457Q512 467 512 480Q512 493 503 503Q493 512 480 512Q467 512 457 503L331 376Q278 415 208 416Q120 414 61 355Q2 296 0 208Q2 120 61 61Q120 2 208 0Q296 2 355 61Q414 120 416 208ZM184 296Q186 318 208 320Q230 318 232 296V232H296Q318 230 320 208Q318 186 296 184H232V120Q230 98 208 96Q186 98 184 120V184H120Q98 186 96 208Q98 230 120 232H184V296Z'],
    'square': [448, 'M0 96Q1 69 19 51Q37 33 64 32H384Q411 33 429 51Q447 69 448 96V416Q447 443 429 461Q411 479 384 480H64Q37 479 19 461Q1 443 0 416V96Z'],
    'pause': [320, 'M48 64Q28 65 14 78Q1 92 0 112V400Q1 420 14 434Q28 447 48 448H80Q100 447 114 434Q127 420 128 400V112Q127 92 114 78Q100 65 80 64H48ZM240 64Q220 65 206 78Q193 92 192 112V400Q193 420 206 434Q220 447 240 448H272Q292 447 306 434Q319 420 320 400V112Q319 92 306 78Q292 65 272 64H240Z'],
    'mouse-pointer': [320, 'M0 55V426V55V426Q2 446 22 448Q32 448 39 441L121 346L179 462Q186 474 198 478Q210 482 222 477Q234 470 238 458Q242 446 236 434L180 320H298Q318 318 320 298Q320 288 313 281L39 38Q32 32 23 32Q2 34 0 55Z'],
    'stop': [384, 'M0 128Q1 101 19 83Q37 65 64 64H320Q347 65 365 83Q383 101 384 128V384Q383 411 365 429Q347 447 320 448H64Q37 447 19 429Q1 411 0 384V128Z'],
    'exchange-alt': [512, 'M32 96H352H32H352V32Q353 11 372 2Q391 -5 407 9L503 105Q512 115 512 128Q512 141 503 151L407 247Q391 261 372 253Q353 245 352 224V160H32Q18 160 9 151Q0 142 0 128Q0 114 9 105Q18 96 32 96ZM480 352Q494 352 503 361Q512 370 512 384Q512 398 503 407Q494 416 480 416H160V480Q159 501 140 510Q121 517 105 503L9 407Q0 397 0 384Q0 371 9 362L105 266Q121 251 140 259Q159 267 160 288V352H480Z'],
    'minus': [448, 'M432 256Q432 270 423 279Q414 288 400 288H48Q34 288 25 279Q16 270 16 256Q16 242 25 233Q34 224 48 224H400Q414 224 423 233Q432 242 432 256Z'],
    'plus': [448, 'M256 80Q256 66 247 57Q238 48 224 48Q210 48 201 57Q192 66 192 80V224H48Q34 224 25 233Q16 242 16 256Q16 270 25 279Q34 288 48 288H192V432Q192 446 201 455Q210 464 224 464Q238 464 247 455Q256 446 256 432V288H400Q414 288 423 279Q432 270 432 256Q432 242 423 233Q414 224 400 224H256V80Z'],
  };

  function svgIcon(name) {
    const icon = ICONS[name];
    if (!icon) return '';
    return `<svg class="a11y-icon" viewBox="0 0 ${icon[0]} 512" aria-hidden="true" focusable="false"><path d="${icon[1]}"/></svg>`;
  }

  class AccessibilityWidget {
    constructor() {
      this.settings = this.loadSettings();
      // this.currentLang = this.settings.language || WIDGET_CONFIG.defaultLang;
      this.currentLang = document.documentElement.lang || WIDGET_CONFIG.defaultLang; // fallback to 'en'
      this.translations = WIDGET_CONFIG.translations[this.currentLang] || WIDGET_CONFIG.translations['en'];
      this.updateUITexts();
      this.isOpen = false;
      this.observers = [];
      this.hasAppliedStyles = false;
      this.reapplyHandle = null;
      this.init();
    }

    init() {
      this.loadExternalResources();
      this.injectStyles();
      this.createWidget();
      this.attachEventListeners();
      this.setupSPAListeners();
      this.applySettings();
    }

    // Reapply settings when the storefront swaps content in without a page load.
    setupSPAListeners() {
      // Coalesce bursts of changes into one pass.
      const scheduleReapply = () => {
        if (this.reapplyHandle) return;
        this.reapplyHandle = setTimeout(() => {
          this.reapplyHandle = null;
          this.applySettings();
        }, 200);
      };

      // The theme re-renders sections through the Section Rendering API; these are the events
      // it dispatches when it does (see assets/events.js).
      for (const eventName of ['cart:update', 'variant:update', 'filter:update']) {
        document.addEventListener(eventName, scheduleReapply);
      }

      // Catch anything else that inserts content: pagination, quick add, app embeds.
      const observer = new MutationObserver((mutations) => {
        // With every setting at its default there is nothing applied to reapply.
        if (this.isDefaultState()) return;

        for (const mutation of mutations) {
          if (mutation.type !== 'childList') continue;

          for (const node of mutation.addedNodes) {
            if (node.nodeType !== Node.ELEMENT_NODE) continue;
            // Ignore the widget building its own UI.
            if (node.closest?.('#a11y-widget-container')) continue;

            scheduleReapply();
            return;
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
      this.observers.push(observer);

      window.addEventListener('popstate', scheduleReapply);
    }

    loadExternalResources() {
      // Load Lexend font for dyslexia support
      if (!document.getElementById('lexend-embed')) {
        const css = `
        @font-face{
          font-family:'Lexend';
          font-style:normal;
          font-weight:400;
          font-display:swap;
          src:url(//sexyplexy.com/cdn/shop/t/15/assets/lexend-400.woff2?v=76422068884982367021780040709) format('woff2');
        }
        @font-face{
          font-family:'Lexend';
          font-style:normal;
          font-weight:700;
          font-display:swap;
          src:url(//sexyplexy.com/cdn/shop/t/15/assets/lexend-700.woff2?v=82817938803879040591780040710) format('woff2');
        }`;
        const style = document.createElement('style');
        style.id = 'lexend-embed';
        style.textContent = css;
        document.head.appendChild(style);
      }
    }

    injectStyles() {
      if (document.getElementById('a11y-widget-styles')) return;

      const style = document.createElement('style');
      style.id = 'a11y-widget-styles';
      style.textContent = `
                /* Widget Container */
                #a11y-widget-container {
                    position: fixed;
                    bottom: 10px;
                    left: 10px;
                    z-index: 999999;
                    font-family: Jost, sans-serif;
                }
                
                /* Toggle Button */
                #a11y-toggle-btn {
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    background: black;
                    color: white;
                    border: none;
                    cursor: pointer;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.3s ease;
                    font-size: 24px;
                }
                
                #a11y-toggle-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(0,0,0,0.2);
                }
                
                /* Panel */
                #a11y-panel {
                    position: absolute;
                    bottom: 66px;
                    left: 0;
                    width: 380px;
                    max-width: calc(100vw - 40px);
                    max-height: calc(100vh - 120px);
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 10px 40px rgba(0,0,0,0.1);
                    display: none;
                    overflow: hidden;
                }
                
                @media (max-height: 700px) {
                    #a11y-panel {
                        bottom: 10px;
                        max-height: calc(100vh - 80px);
                    }
                }
                
                @media (max-width: 420px) {
                    #a11y-panel {
                        width: calc(100vw - 40px);
                        left: 0;
                    }
                }
                
                #a11y-panel.active {
                    display: flex;
                    flex-direction: column;
                    animation: slideIn 0.3s ease;
                }
                
                @keyframes slideIn {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                
                /* Header */
                .a11y-header {
                    background: #F7F7F7;
                    padding: 20px;
                    border-bottom: 1px solid #e5e5e5;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                
                .a11y-header h3 {
                    font-size: 24px;
                    margin: 0;
                    color: #5c5c5c;
                }
                
                .a11y-header-actions {
                    display: flex;
                    gap: 8px;
                    align-items: center;
                }
                
                .a11y-lang-toggle {
                    display: flex;
                    background: #white;
                    border-radius: 8px;
                    padding: 2px;
                    visibility: hidden;
                    height: 0;
                    width: 0;
                    position: absolute;
                    top: 0;
                    right: 0;
                    pointer-events: none;
                }
                
                .a11y-lang-btn {
                    padding: 6px 12px;
                    border: none;
                    background: transparent;
                    cursor: pointer;
                    border-radius: 6px;
                    font-size: 12px;
                    font-weight: 500;
                    color: #5c5c5c;
                    transition: all 0.2s;
                }
                
                .a11y-lang-btn.active {
                    background: white;
                    color: #5c5c5c;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                }
                
                .a11y-close-btn {
                    background: transparent;
                    border: none;
                    color: #5c5c5c;
                    font-size: 20px;
                    cursor: pointer;
                    padding: 4px;
                    width: 32px;
                    height: 32px;
                    border-radius: 6px;
                    transition: all 0.2s;
                    line-height: 0;
                }
                
                .a11y-close-btn:hover {
                    background: transparent;
                    color: #5c5c5c;
                }
                
                /* Content */
                .a11y-content {
                    padding: 20px;
                    overflow-y: auto;
                    max-height: calc(100vh - 380px);
                }
                
                @media (max-height: 700px) {
                    .a11y-content {
                        padding: 15px;
                        max-height: calc(100vh - 340px);
                    }
                }
                
                /* Grid */
                .a11y-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 12px;
                    margin-bottom: 20px;
                }
                
                /* Cards */
                .a11y-card {
                    background: #f7f7f7;
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                    padding: 16px;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.2s;
                }
                
                .a11y-card:hover {
                    border-color: #5c5c5c;
                    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
                }
                
                .a11y-card.active {
                    background:rgb(195, 195, 195);
                    border-color: #5c5c5c;
                }
                
                .a11y-card-icon {
                    font-size: 24px;
                    margin-bottom: 8px;
                    color: #5c5c5c;
                }
                
                .a11y-card.active .a11y-card-icon {
                    color: #5c5c5c;
                }
                
                .a11y-card-label {
                    font-size: 13px;
                    color: #5c5c5c;
                    font-weight: 500;
                }
                
                /* Sliders */
                .a11y-slider-group {
                    background: #f7f7f7;
                    border-radius: 12px;
                    padding: 16px;
                    margin-bottom: 12px;
                }
                
                .a11y-slider-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 12px;
                }
                
                .a11y-slider-label {
                    font-size: 14px;
                    font-weight: 500;
                    color: #1f2937;
                }
                
                .a11y-slider-value {
                    font-size: 14px;
                    color: #6b7280;
                    font-weight: 500;
                }
                
                .a11y-slider-controls {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }
                
                .a11y-slider-btn {
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    background: white;
                    border: 1px solid #e5e7eb;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.2s;
                    color: #5c5c5c;
                }
                
                .a11y-slider-btn:hover {
                    background: #f3f4f6;
                    border-color: #d1d5db;
                }
                
                .a11y-slider {
                    flex: 1;
                    height: 4px;
                    -webkit-appearance: none;
                    appearance: none;
                    background: #e5e7eb;
                    border-radius: 2px;
                    outline: none;
                    cursor: pointer;
                }
                
                .a11y-slider::-webkit-slider-thumb {
                    -webkit-appearance: none;
                    appearance: none;
                    width: 20px;
                    height: 20px;
                    background: #5c5c5c;
                    border-radius: 50%;
                    cursor: pointer;
                    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
                    transition: all 0.2s;
                }
                
                .a11y-slider::-webkit-slider-thumb:hover {
                    transform: scale(1.2);
                }
                
                .a11y-slider::-moz-range-thumb {
                    width: 20px;
                    height: 20px;
                    background: #5c5c5c;
                    border-radius: 50%;
                    cursor: pointer;
                    border: none;
                    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
                }
                
                /* Footer */
                .a11y-footer {
                    padding: 16px 20px;
                    border-top: 1px solid #e5e5e5;
                    background: white;
                }
                
                .a11y-btn {
                    width: 100%;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                }
                
                .a11y-btn-reset .a11y-icon {
                  font-size: 14px;
                }

                /* Inline SVG icons scale from the parent's font-size, as the webfont glyphs did */
                .a11y-icon {
                    display: inline-block;
                    height: 1em;
                    width: auto;
                    max-width: 100%;
                    fill: currentColor;
                    vertical-align: -0.125em;
                    flex: none;
                }
                
                .a11y-reset-all {
                    padding: 0 20px 20px 20px;
                    background: #f7f7f7;
                }
                
                .a11y-reset-all button {
                    width: 100%;
                    padding: 10px;
                    background: transparent;
                    border: 1px solid transparent;
                    border-radius: 8px;
                    color: #5c5c5c;
                    font-size: 13px;
                    cursor: pointer;
                    transition: all 0.2s;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                }
                
                .a11y-reset-all button:hover {
                    background: transparent;
                    border-color: transparent;
                    color: #5c5c5c;
                }
                
                /* Marks elements the widget has restyled, so font-size cascades cleanly */
                .a11y-text {
                    font-size: inherit !important;
                }
                
                /* Accessibility Features */
                body.a11y-dyslexia *:not([class*="fa"]) {
                    font-family: 'Lexend', Arial, sans-serif !important;
                }
                
                body.a11y-highlight-links a {
                    text-decoration: underline !important;
                    text-decoration-thickness: 2px !important;
                    text-underline-offset: 2px !important;
                }
                
                body.a11y-hide-images img {
                    opacity: 0 !important;
                    visibility: hidden !important;
                }
                
                body.a11y-highlight-headings h1::before,
                body.a11y-highlight-headings h2::before,
                body.a11y-highlight-headings h3::before,
                body.a11y-highlight-headings h4::before,
                body.a11y-highlight-headings h5::before,
                body.a11y-highlight-headings h6::before {
                    content: '' !important;
                    position: absolute !important;
                    left: 0 !important;
                    top: 0 !important;
                    bottom: 0 !important;
                    width: 4px !important;
                    background: #5c5c5c !important;
                }
                
                body.a11y-highlight-headings h1,
                body.a11y-highlight-headings h2,
                body.a11y-highlight-headings h3,
                body.a11y-highlight-headings h4,
                body.a11y-highlight-headings h5,
                body.a11y-highlight-headings h6 {
                    position: relative !important;
                    padding-left: 20px !important;
                }
                
                /* High Contrast */
                body.a11y-high-contrast {
                    background: #000 !important;
                    color: #fff !important;
                }
                
                body.a11y-high-contrast * {
                    background-color: #000 !important;
                    color: #fff !important;
                    border-color: #fff !important;
                }
                
                body.a11y-high-contrast a {
                    color: #ffff00 !important;
                }
                
                body.a11y-high-contrast button {
                    background: #fff !important;
                    color: #000 !important;
                }
                
                /* Dark Mode */
                body.a11y-dark-mode {
                    background: #1a1a1a !important;
                    color: #e0e0e0 !important;
                }
                
                body.a11y-dark-mode * {
                    background-color: #1a1a1a !important;
                    color: #e0e0e0 !important;
                    border-color: #444 !important;
                }
                
                body.a11y-dark-mode a {
                    color: #66b3ff !important;
                }
                
                /* Focus Outline */
                body.a11y-focus-outline *:focus {
                    outline: 6px solid #ff0000 !important;
                    outline-offset: 6px !important;
                }
                
                /* Reduce Motion */
                body.a11y-reduce-motion * {
                    animation: none !important;
                    transition: none !important;
                }
                
                /* Large Cursor */
                body.a11y-cursor-size * {
                    cursor: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><path fill="black" stroke="white" stroke-width="2" d="M8 8 L28 20 L20 24 L24 36 L20 38 L16 26 L8 30 Z"/></svg>') 0 0, auto !important;
                }
                
                /* Stop Autoplay */
                body.a11y-stop-autoplay video,
                body.a11y-stop-autoplay audio {
                    autoplay: false !important;
                    pause: true !important;
                }
                
                /* Invert Colors */
                html.a11y-invert::before{
                    content:"";
                    position:fixed;
                    inset:0;
                    background:#fff;
                    mix-blend-mode:difference;
                    pointer-events:none;
                    z-index:2147483647;
                }
                
                html.a11y-invert img,
                html.a11y-invert video{
                    mix-blend-mode:normal;
                }
                
                /* Reading Mask */
                #a11y-reading-mask {
                    position: fixed;
                    left: 0;
                    right: 0;
                    height: 120px;
                    pointer-events: none;
                    z-index: 999998;
                    display: none;
                }
                
                #a11y-reading-mask::before,
                #a11y-reading-mask::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    right: 0;
                    background: rgba(0,0,0,0.3);
                }
                
                #a11y-reading-mask::before {
                    top: -100vh;
                    height: 100vh;
                }
                
                #a11y-reading-mask::after {
                    bottom: -100vh;
                    height: 100vh;
                }
                
                body.a11y-reading-mask #a11y-reading-mask {
                    display: block;
                }
                
                /* Text Magnifier */
                .a11y-magnifier {
                    position: fixed;
                    width: 400px;
                    max-width: 90vw;
                    padding: 20px;
                    background: rgba(255, 255, 255, 0.98);
                    border: 2px solid #2563eb;
                    border-radius: 8px;
                    box-shadow: 0 8px 32px rgba(0,0,0,0.2);
                    pointer-events: none;
                    z-index: 999997;
                    display: none;
                    font-size: 150%;
                    line-height: 1.6;
                    word-wrap: break-word;
                    color: #000;
                }
                
                body.a11y-text-magnifier .a11y-magnifier {
                    display: block;
                }
                
                .a11y-magnifier::before {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 2px;
                    height: 20px;
                    background: rgba(37, 99, 235, 0.3);
                    pointer-events: none;
                }
                
                /* Responsive styles */
                @media (max-width: 420px) {
                    .a11y-grid {
                        grid-template-columns: 1fr;
                        gap: 8px;
                    }
                    
                    .a11y-slider-group {
                        padding: 12px;
                    }
                    
                    .a11y-content {
                        padding: 15px;
                    }
                }
            `;
      document.head.appendChild(style);
    }

    createWidget() {
      // Prevent creating duplicate widgets
      if (document.getElementById('a11y-widget-container')) return;

      // Take over from the boot stub's placeholder button (see snippets/a11y-boot.liquid)
      document.getElementById('a11y-boot-container')?.remove();

      const container = document.createElement('div');
      container.id = 'a11y-widget-container';

      // Create the main toggle button
      const toggleBtn = document.createElement('button');
      toggleBtn.id = 'a11y-toggle-btn';
      toggleBtn.setAttribute('aria-label', this.translations.title);
      toggleBtn.innerHTML = svgIcon('universal-access');

      // Create the settings panel
      const panel = document.createElement('div');
      panel.id = 'a11y-panel';
      panel.innerHTML = this.getPanelHTML();

      container.appendChild(toggleBtn);
      container.appendChild(panel);
      document.body.appendChild(container);

      // Create additional accessibility elements
      this.createReadingMask();
      this.createMagnifier();
    }

    getPanelHTML() {
      return `
                <div class="a11y-header">
                    <h3 class="h4">${this.translations.title}</h3>
                    <div class="a11y-header-actions">
                      <div class="a11y-lang-toggle">
                         <button class="a11y-lang-btn ${this.currentLang === 'en' ? 'active' : ''}" data-lang="en">EN</button>
                         <button class="a11y-lang-btn ${this.currentLang === 'hr' ? 'active' : ''}" data-lang="hr">HR</button>
                      </div>
                        <button class="a11y-close-btn" aria-label="Close">
                            ${svgIcon('times')}
                        </button>
                    </div>
                </div>
                <div class="a11y-content">
                    <div class="a11y-grid">
                        ${this.createFeatureCards()}
                    </div>
                    ${this.createSliders()}
                </div>
                <div class="a11y-footer">
                    <button class="button a11y-btn a11y-btn-reset">
                        ${svgIcon('undo')}
                        <span>${this.translations.reset}</span>
                    </button>
                </div>
            `;
    }

    createFeatureCards() {
      const features = [
        { id: 'readingMask', icon: 'eye', label: this.translations.readingMask },
        { id: 'highContrast', icon: 'adjust', label: this.translations.highContrast },
        { id: 'darkMode', icon: 'moon', label: this.translations.darkMode },
        { id: 'dyslexiaFont', icon: 'font', label: this.translations.dyslexiaFont },
        { id: 'textAlignRight', icon: 'align-right', label: this.translations.textAlign },
        { id: 'textAlignCenter', icon: 'align-center', label: this.translations.textAlignCenter },
        { id: 'textAlignLeft', icon: 'align-left', label: this.translations.textAlignLeft },
        { id: 'highlightLinks', icon: 'link', label: this.translations.highlightLinks },
        { id: 'hideImages', icon: 'image', label: this.translations.hideImages },
        { id: 'highlightHeadings', icon: 'heading', label: this.translations.highlightHeadings },
        { id: 'textMagnifier', icon: 'search-plus', label: this.translations.textMagnifier },
        { id: 'focusOutline', icon: 'square', label: this.translations.focusOutline },
        { id: 'reduceMotion', icon: 'pause', label: this.translations.reduceMotion },
        { id: 'cursorSize', icon: 'mouse-pointer', label: this.translations.cursorSize },
        { id: 'stopAutoplay', icon: 'stop', label: this.translations.stopAutoplay },
        { id: 'invertColors', icon: 'exchange-alt', label: this.translations.invertColors },
      ];

      return features
        .map((f) => {
          const isActive = this.isFeatureActive(f.id);
          return `
                    <div class="a11y-card ${isActive ? 'active' : ''}" data-feature="${f.id}">
                        <div class="a11y-card-icon">
                            ${svgIcon(f.icon)}
                        </div>
                        <div class="a11y-card-label">${f.label}</div>
                    </div>
                `;
        })
        .join('');
    }

    createSliders() {
      const sliders = [
        { id: 'fontSize', label: this.translations.fontSize, min: 80, max: 150 },
        { id: 'lineHeight', label: this.translations.lineHeight, min: 100, max: 200 },
        { id: 'letterSpacing', label: this.translations.letterSpacing, min: 100, max: 150 },
        { id: 'contentScale', label: this.translations.contentScale, min: 80, max: 130 },
        { id: 'columnWidth', label: this.translations.columnWidth, min: 400, max: 1200 },
      ];

      return sliders
        .map(
          (s) => `
                <div class="a11y-slider-group">
                    <div class="a11y-slider-header">
                        <span class="a11y-slider-label">${s.label}</span>
                        <span class="a11y-slider-value" id="${s.id}Value">${this.settings[s.id] || (s.id === 'columnWidth' ? 600 : 100)}${s.id === 'columnWidth' ? 'px' : '%'}</span>
                    </div>
                    <div class="a11y-slider-controls">
                        <button class="a11y-slider-btn" data-action="decrease" data-target="${s.id}">
                            ${svgIcon('minus')}
                        </button>
                        <input type="range" class="a11y-slider" id="${s.id}" 
                            min="${s.min}" max="${s.max}" value="${this.settings[s.id] || (s.id === 'columnWidth' ? 600 : 100)}">
                        <button class="a11y-slider-btn" data-action="increase" data-target="${s.id}">
                            ${svgIcon('plus')}
                        </button>
                    </div>
                </div>
            `,
        )
        .join('');
    }

    createReadingMask() {
      if (!document.getElementById('a11y-reading-mask')) {
        const mask = document.createElement('div');
        mask.id = 'a11y-reading-mask';
        document.body.appendChild(mask);
      }
    }

    createMagnifier() {
      if (!document.querySelector('.a11y-magnifier')) {
        const magnifier = document.createElement('div');
        magnifier.className = 'a11y-magnifier';
        magnifier.setAttribute('aria-hidden', 'true');
        document.body.appendChild(magnifier);
      }
    }

    isFeatureActive(feature) {
      if (feature.startsWith('textAlign')) {
        const align = feature.replace('textAlign', '').toLowerCase();
        return this.settings.textAlign === align;
      }
      return this.settings[feature] || false;
    }

    attachEventListeners() {
      // Main toggle button
      document.getElementById('a11y-toggle-btn').addEventListener('click', () => {
        this.togglePanel();
      });

      // Close button
      document.querySelector('.a11y-close-btn').addEventListener('click', () => {
        this.togglePanel();
      });

      // Language toggle buttons
      document.querySelectorAll('.a11y-lang-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          this.changeLanguage(e.target.dataset.lang);
        });
      });

      // Set active button based on currentLang on page load
      document.querySelectorAll('.a11y-lang-btn').forEach((btn) => {
        btn.classList.toggle('active', btn.dataset.lang === this.currentLang);
      });

      // Feature toggle cards
      document.querySelectorAll('.a11y-card').forEach((card) => {
        card.addEventListener('click', () => {
          this.toggleFeature(card.dataset.feature, card);
        });
      });

      // Range sliders
      document.querySelectorAll('.a11y-slider').forEach((slider) => {
        slider.addEventListener('input', (e) => {
          const id = e.target.id;
          const value = e.target.value;
          const suffix = id === 'columnWidth' ? 'px' : '%';
          document.getElementById(id + 'Value').textContent = value + suffix;
          this.settings[id] = parseInt(value);
          this.applySettings();
          this.saveSettings();
        });
      });

      // Slider increment/decrement buttons
      document.querySelectorAll('.a11y-slider-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const action = btn.dataset.action;
          const target = btn.dataset.target;
          const slider = document.getElementById(target);
          const current = parseInt(slider.value);
          const step = target === 'columnWidth' ? 50 : 1;

          if (action === 'increase') {
            slider.value = Math.min(current + step, parseInt(slider.max));
          } else {
            slider.value = Math.max(current - step, parseInt(slider.min));
          }

          slider.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });

      // Reset button
      document.querySelector('.a11y-btn-reset').addEventListener('click', () => {
        this.resetSettings();
      });

      // Set up mouse tracking for reading aids
      this.initMouseTracking();
    }

    initMouseTracking() {
      let magnifierTimeout;

      document.addEventListener('mousemove', (e) => {
        // Update reading mask position
        if (this.settings.readingMask) {
          const mask = document.getElementById('a11y-reading-mask');
          if (mask) {
            mask.style.top = e.clientY - 60 + 'px';
          }
        }

        // Update text magnifier
        if (this.settings.textMagnifier) {
          clearTimeout(magnifierTimeout);
          magnifierTimeout = setTimeout(() => {
            this.updateMagnifier(e);
          }, 10);
        }
      });
    }

    updateMagnifier(e) {
      const magnifier = document.querySelector('.a11y-magnifier');
      if (!magnifier) return;

      // Temporarily hide magnifier to get the element underneath
      magnifier.style.display = 'none';
      const targetElement = document.elementFromPoint(e.clientX, e.clientY);
      magnifier.style.display = 'block';

      if (!targetElement || targetElement === document.body || targetElement === document.documentElement) {
        magnifier.style.display = 'none';
        return;
      }

      // Don't show magnifier over the widget itself
      if (targetElement.closest('#a11y-widget-container')) {
        magnifier.style.display = 'none';
        return;
      }

      // Find the text container
      let textContainer = targetElement;
      const blockTags = ['P', 'DIV', 'ARTICLE', 'SECTION', 'LI', 'TD', 'TH', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'SPAN', 'A'];

      // Look for the nearest element with text content
      while (textContainer && textContainer.textContent.trim().length === 0) {
        textContainer = textContainer.parentElement;
      }

      // For inline elements, try to get the parent block
      if (textContainer && !blockTags.includes(textContainer.tagName)) {
        const parent = textContainer.closest(blockTags.join(','));
        if (parent) textContainer = parent;
      }

      if (!textContainer || !textContainer.textContent.trim()) {
        magnifier.style.display = 'none';
        return;
      }

      // Extract and clean text content
      const fullText = textContainer.textContent.trim().replace(/\s+/g, ' ');
      const words = fullText.split(' ');

      if (words.length === 0) {
        magnifier.style.display = 'none';
        return;
      }

      // Calculate relative position for word estimation
      const rect = textContainer.getBoundingClientRect();
      const relativeX = (e.clientX - rect.left) / rect.width;
      const relativeY = (e.clientY - rect.top) / rect.height;

      // Estimate which word the cursor is near
      const estimatedPosition = Math.floor(words.length * (relativeY * 0.7 + relativeX * 0.3));
      const wordIndex = Math.max(0, Math.min(estimatedPosition, words.length - 1));

      // Show a window of words around the cursor
      const wordsToShow = 20;
      const wordsBeforeCursor = 8;

      let startIndex = Math.max(0, wordIndex - wordsBeforeCursor);
      let endIndex = Math.min(words.length, startIndex + wordsToShow);

      // Adjust if we're near the end
      if (endIndex - startIndex < wordsToShow && startIndex > 0) {
        startIndex = Math.max(0, endIndex - wordsToShow);
      }

      // Build the display text
      let displayText = words.slice(startIndex, endIndex).join(' ');

      // Add ellipsis for truncated text
      if (startIndex > 0) displayText = '... ' + displayText;
      if (endIndex < words.length) displayText = displayText + ' ...';

      // Update magnifier content
      magnifier.textContent = displayText;

      // Position the magnifier near the cursor
      let left = e.clientX + 20;
      let top = e.clientY - magnifier.offsetHeight - 10;

      // Keep magnifier within viewport
      const magnifierWidth = magnifier.offsetWidth;
      const magnifierHeight = magnifier.offsetHeight;

      if (left + magnifierWidth > window.innerWidth - 20) {
        left = e.clientX - magnifierWidth - 20;
      }
      if (top < 20) {
        top = e.clientY + 20;
      }
      if (top + magnifierHeight > window.innerHeight - 20) {
        top = window.innerHeight - magnifierHeight - 20;
      }

      magnifier.style.left = left + 'px';
      magnifier.style.top = top + 'px';
    }

    toggleFeature(feature, card) {
      if (feature.startsWith('textAlign')) {
        // Handle text alignment features
        document.querySelectorAll('[data-feature^="textAlign"]').forEach((c) => {
          c.classList.remove('active');
        });

        const align = feature.replace('textAlign', '').toLowerCase();
        if (this.settings.textAlign === align) {
          this.settings.textAlign = 'default';
        } else {
          this.settings.textAlign = align;
          card.classList.add('active');
        }
      } else {
        // Handle boolean toggle features
        this.settings[feature] = !this.settings[feature];
        card.classList.toggle('active');
      }

      this.applySettings();
      this.saveSettings();
    }

    changeLanguage(lang) {
      this.currentLang = lang;
      this.translations = WIDGET_CONFIG.translations[lang];
      this.settings.language = lang;

      // Update language toggle buttons
      document.querySelectorAll('.a11y-lang-btn').forEach((btn) => {
        btn.classList.toggle('active', btn.dataset.lang === lang);
      });

      // Update all UI text
      this.updateUITexts();
      this.saveSettings();
    }

    updateUITexts() {
      if (!this.translations) return; // translations not ready yet

      // Update header title
      const header = document.querySelector('.a11y-header h3');
      if (header) header.textContent = this.translations.title;

      // Update feature card labels
      const cardMappings = {
        readingMask: this.translations.readingMask,
        highContrast: this.translations.highContrast,
        darkMode: this.translations.darkMode,
        dyslexiaFont: this.translations.dyslexiaFont,
        textAlignRight: this.translations.textAlign,
        textAlignCenter: this.translations.textAlignCenter,
        textAlignLeft: this.translations.textAlignLeft,
        highlightLinks: this.translations.highlightLinks,
        hideImages: this.translations.hideImages,
        highlightHeadings: this.translations.highlightHeadings,
        textMagnifier: this.translations.textMagnifier,
        focusOutline: this.translations.focusOutline,
        reduceMotion: this.translations.reduceMotion,
        cursorSize: this.translations.cursorSize,
        stopAutoplay: this.translations.stopAutoplay,
        invertColors: this.translations.invertColors,
      };

      Object.entries(cardMappings).forEach(([feature, text]) => {
        const label = document.querySelector(`[data-feature="${feature}"] .a11y-card-label`);
        if (label && text) label.textContent = text;
      });

      // Update slider labels
      const sliderMappings = {
        fontSize: this.translations.fontSize,
        lineHeight: this.translations.lineHeight,
        letterSpacing: this.translations.letterSpacing,
        contentScale: this.translations.contentScale,
        columnWidth: this.translations.columnWidth,
      };

      Object.entries(sliderMappings).forEach(([id, text]) => {
        const slider = document.getElementById(id);
        if (slider && text) {
          const label = slider.closest('.a11y-slider-group')?.querySelector('.a11y-slider-label');
          if (label) label.textContent = text;
        }
      });

      // Update reset button text
      const resetBtn = document.querySelector('.a11y-btn-reset span');
      if (resetBtn && this.translations.reset) resetBtn.textContent = this.translations.reset;
    }

    togglePanel() {
      this.isOpen = !this.isOpen;
      const panel = document.getElementById('a11y-panel');
      panel.classList.toggle('active', this.isOpen);
    }

    /** True when every setting sits at its default, so the page needs no adjustment. */
    isDefaultState() {
      const defaults = this.getDefaultSettings();

      return Object.keys(defaults).every(
        // `language` does not affect the page, only the panel's own labels.
        (key) => key === 'language' || this.settings[key] === defaults[key]
      );
    }

    applySettings() {
      // Nothing is applied and nothing needs applying, so skip the document-wide pass entirely.
      // `hasAppliedStyles` keeps the pass running once more after a reset, so the cleanup below
      // still gets a chance to strip styles from an earlier non-default state.
      if (this.isDefaultState() && !this.hasAppliedStyles) return;
      this.hasAppliedStyles = !this.isDefaultState();

      // Remove all feature classes for clean state
      document.body.classList.remove('a11y-dyslexia', 'a11y-highlight-links', 'a11y-hide-images', 'a11y-highlight-headings', 'a11y-reading-mask', 'a11y-text-magnifier', 'a11y-high-contrast', 'a11y-dark-mode', 'a11y-focus-outline', 'a11y-reduce-motion', 'a11y-cursor-size', 'a11y-stop-autoplay');

      // Clear existing inline styles. Every property applied below must be cleared here,
      // otherwise resetting a slider to its default leaves the old value applied: the apply
      // step is skipped at the default value, so nothing overwrites the stale declaration.
      document.documentElement.style.fontSize = '';
      document.body.style.fontSize = '';
      document.body.style.lineHeight = '';
      document.body.style.letterSpacing = '';
      document.body.style.zoom = '';

      // Text-bearing elements to restyle. The widget originally shipped with ~56 extra
      // Flarum forum selectors (.Post-body, [class*="Discussion"], ...); none of those classes
      // exist in this theme, so they were pure cost on every pass and have been removed.
      const textSelectors = [
        'p',
        'div:not([class*="a11y"])',
        'li',
        'td',
        'th',
        'article',
        'section',
        'span',
        'a',
        '.container',
      ];

      const textElements = document.querySelectorAll(textSelectors.join(', '));

      // Elements styled on an earlier pass are tagged with `a11y-text`, which makes a
      // div stop matching the `div:not([class*="a11y"])` selector above. Such elements drop out
      // of textElements, so cleaning only that list would strand their inline styles forever.
      // Collect them explicitly and clear the union.
      const styledElements = new Set([...textElements, ...document.querySelectorAll('.a11y-text')]);

      // Clear existing styles from all elements
      styledElements.forEach((el) => {
        el.style.fontSize = '';
        el.style.lineHeight = '';
        el.style.letterSpacing = '';
        el.style.textAlign = '';
        el.style.maxWidth = '';
        el.classList.remove('a11y-text');
      });

      // Apply font size
      if (this.settings.fontSize && this.settings.fontSize !== 100) {
        const fontSizePercent = this.settings.fontSize + '%';

        // Set global font size
        document.documentElement.style.setProperty('font-size', fontSizePercent, 'important');
        document.body.style.setProperty('font-size', fontSizePercent, 'important');

        textElements.forEach((el) => {
          el.style.setProperty('font-size', fontSizePercent, 'important');
          el.classList.add('a11y-text');
        });
      }

      // Apply line height
      if (this.settings.lineHeight && this.settings.lineHeight !== 100) {
        const value = this.settings.lineHeight / 100;
        document.body.style.setProperty('line-height', value, 'important');
        textElements.forEach((el) => {
          el.style.setProperty('line-height', value, 'important');
        });
      }

      // Apply letter spacing
      if (this.settings.letterSpacing && this.settings.letterSpacing !== 100) {
        const value = (this.settings.letterSpacing - 100) * 0.05;
        document.body.style.setProperty('letter-spacing', value + 'em', 'important');
        textElements.forEach((el) => {
          el.style.setProperty('letter-spacing', value + 'em', 'important');
        });
      }

      // Apply content scaling
      if (this.settings.contentScale && this.settings.contentScale !== 100) {
        document.body.style.zoom = this.settings.contentScale + '%';
      }

      // Apply column width
      if (this.settings.columnWidth && this.settings.columnWidth !== 600) {
        textElements.forEach((el) => {
          el.style.maxWidth = this.settings.columnWidth + 'px';
        });
      }

      // Apply text alignment
      if (this.settings.textAlign && this.settings.textAlign !== 'default') {
        textElements.forEach((el) => {
          el.style.setProperty('text-align', this.settings.textAlign, 'important');
        });
      }

      // Apply feature classes
      if (this.settings.dyslexiaFont) document.body.classList.add('a11y-dyslexia');
      if (this.settings.highlightLinks) document.body.classList.add('a11y-highlight-links');
      if (this.settings.hideImages) document.body.classList.add('a11y-hide-images');
      if (this.settings.highlightHeadings) document.body.classList.add('a11y-highlight-headings');
      if (this.settings.readingMask) document.body.classList.add('a11y-reading-mask');
      if (this.settings.textMagnifier) document.body.classList.add('a11y-text-magnifier');
      if (this.settings.highContrast) document.body.classList.add('a11y-high-contrast');
      if (this.settings.darkMode) document.body.classList.add('a11y-dark-mode');
      if (this.settings.focusOutline) document.body.classList.add('a11y-focus-outline');
      if (this.settings.reduceMotion) document.body.classList.add('a11y-reduce-motion');
      if (this.settings.cursorSize) document.body.classList.add('a11y-cursor-size');
      if (this.settings.stopAutoplay) {
        document.body.classList.add('a11y-stop-autoplay');
        document.querySelectorAll('video[autoplay], audio[autoplay]').forEach((media) => {
          media.pause();
          media.removeAttribute('autoplay');
        });
      }

      // Handle color inversion
      if (this.settings.invertColors) {
        document.documentElement.classList.add('a11y-invert');
      } else {
        document.documentElement.classList.remove('a11y-invert');
      }
    }

    // Helper methods for dynamic CSS rules
    resetSettings() {
      // Reset all numeric settings to defaults
      this.settings.fontSize = 100;
      this.settings.lineHeight = 100;
      this.settings.letterSpacing = 100;
      this.settings.contentScale = 100;
      this.settings.columnWidth = 600;
      this.settings.textAlign = 'default';

      // Reset all boolean features
      this.settings.readingMask = false;
      this.settings.highContrast = false;
      this.settings.darkMode = false;
      this.settings.dyslexiaFont = false;
      this.settings.highlightLinks = false;
      this.settings.hideImages = false;
      this.settings.highlightHeadings = false;
      this.settings.textMagnifier = false;
      this.settings.focusOutline = false;
      this.settings.reduceMotion = false;
      this.settings.cursorSize = false;
      this.settings.stopAutoplay = false;
      this.settings.invertColors = false;

      // Update slider values in UI
      ['fontSize', 'lineHeight', 'letterSpacing', 'contentScale'].forEach((id) => {
        const slider = document.getElementById(id);
        if (slider) {
          slider.value = 100;
          document.getElementById(id + 'Value').textContent = '100%';
        }
      });

      // Update column width slider
      const columnSlider = document.getElementById('columnWidth');
      if (columnSlider) {
        columnSlider.value = 600;
        document.getElementById('columnWidthValue').textContent = '600px';
      }

      // Remove active state from all feature cards
      document.querySelectorAll('.a11y-card').forEach((card) => {
        card.classList.remove('active');
      });

      this.applySettings();
      this.saveSettings();
    }

    getDefaultSettings() {
      return {
        fontSize: 100,
        lineHeight: 100,
        letterSpacing: 100,
        contentScale: 100,
        columnWidth: 600,
        textAlign: 'default',
        language: this.currentLang,
        readingMask: false,
        highContrast: false,
        darkMode: false,
        dyslexiaFont: false,
        highlightLinks: false,
        hideImages: false,
        highlightHeadings: false,
        textMagnifier: false,
        focusOutline: false,
        reduceMotion: false,
        cursorSize: false,
        stopAutoplay: false,
        invertColors: false,
      };
    }

    saveSettings() {
      try {
        localStorage.setItem(WIDGET_CONFIG.storageKey, JSON.stringify(this.settings));
      } catch (e) {
        console.warn('Could not save accessibility settings:', e);
      }
    }

    loadSettings() {
      try {
        const saved = localStorage.getItem(WIDGET_CONFIG.storageKey);
        if (saved) {
          return { ...this.getDefaultSettings(), ...JSON.parse(saved) };
        }
      } catch (e) {
        console.warn('Could not load accessibility settings:', e);
      }
      return this.getDefaultSettings();
    }

    // Cleanup method for observers and intervals
    destroy() {
      // Stop all observers
      this.observers.forEach((observer) => observer.disconnect());
      this.observers = [];

      // Cancel a pending reapply
      if (this.reapplyHandle) {
        clearTimeout(this.reapplyHandle);
        this.reapplyHandle = null;
      }

    }
  }

  // Initialize the accessibility widget
  function initAccessibilityWidget() {
    if (window.accessibilityWidget) return;
    window.accessibilityWidget = new AccessibilityWidget();
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccessibilityWidget);
  } else {
    initAccessibilityWidget();
  }
})();
